import { List, Record } from "immutable";

export const eagleviewProductFromJSON = (json: Partial<IEagleviewProductData>): EagleviewProductRecord => {
  const data = { ...(json as any) };

  if (data.product_id) {
    data.id = data.product_id;
  }

  if (json.delivery_productIds) {
    data.delivery_productIds = List(json.delivery_productIds);
  }
  if (json.delivery_products) {
    data.delivery_products = List(json.delivery_products.map((p) => eagleviewProductFromJSON(p)));
  }
  if (json.add_on_products) {
    data.add_on_products = List(json.add_on_products.map((p) => eagleviewProductFromJSON(p)));
  }

  return new EagleviewProductRecord(data);
};

export interface IEagleviewProductData {
  product_id: number;
  name: string;
  description: string;
  product_group: string;
  is_temporarily_unavailable: boolean;
  price_min: number;
  price_max: number;
  delivery_productIds: number[];
  delivery_products: IEagleviewProductData[];
  add_on_products?: IEagleviewProductData[];
  detailed_description: string;
}

export interface IEagleviewProductRecord {
  id: number;
  name: string;
  description: string;
  product_group: string;
  is_temporarily_unavailable: boolean;
  price_min: number;
  price_max: number;
  delivery_productIds: List<number>;
  delivery_products: List<EagleviewProductRecord>;
  add_on_products?: List<EagleviewProductRecord>;
  detailed_description: string;
}

export const defaultEagleviewProductProps = {
  id: 0,
  name: "",
  description: "",
  product_group: "",
  is_temporarily_unavailable: false,
  price_min: 0,
  price_max: 0,
  delivery_productIds: List<number>(),
  delivery_products: List<EagleviewProductRecord>(),
  add_on_products: List<EagleviewProductRecord>(),
  detailed_description: "",
};

export class EagleviewProductRecord
  extends Record<IEagleviewProductRecord>(defaultEagleviewProductProps)
  implements IEagleviewProductRecord {}
